import * as React from 'react';

export interface SwitchProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className = '', checked = false, onCheckedChange, disabled, onClick, ...props }, ref) => {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        ref={ref}
        disabled={disabled}
        onClick={(e) => {
          onClick?.(e);
          if (!disabled) onCheckedChange?.(!checked);
        }}
        className={`shadcn-switch ${checked ? 'checked' : ''} ${className}`.trim()}
        {...props}
      >
        <span className="shadcn-switch-thumb" />
      </button>
    );
  }
);
Switch.displayName = 'Switch';
